import store from '@/store'

export default {
  permissions: null,
  permissionBrokers: null,
  install: function (_Vue) {
    _Vue.prototype.$acl = this
  },
  setPermissions: function (perms) {
    this.permissions = perms
    store.commit('user/userInfos', { permissions: perms })
  },
  setPermissionBrokers: function (perms) {
    this.permissionBrokers = perms
    store.commit('user/userInfos', { permissionBrokers: perms })
  },
  isAllowed: function (role) {
    if (role && role !== '') {
      const roles = store.getters && store.getters.userPermission
      return (store.getters && store.getters.isAdmin) || roles.indexOf('|' + role + '|') !== -1
    } else {
      return false
    }
  },
  isAllowedBroker: function (role) {
    if (role && role !== '') {
      const roles = store.getters && store.getters.userPermissionBroker
      return roles.indexOf('|' + role + '|') !== -1 // (store.getters && store.getters.isAdmin) ||
    } else {
      return false
    }
  }
}
